var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrongIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_201_1151",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9Z",
    fill: "#EF8686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9M17 9M17 9M1 9M9 1M17 9M9 17M1 9M9 17V16C5.13401 16 2 12.866 2 9H1H0C0 13.9706 4.02944 18 9 18V17ZM17 9H16C16 12.866 12.866 16 9 16V17V18C13.9706 18 18 13.9706 18 9H17ZM9 1V2C12.866 2 16 5.13401 16 9H17H18C18 4.02944 13.9706 0 9 0V1ZM9 1V0C4.02944 0 0 4.02944 0 9H1H2C2 5.13401 5.13401 2 9 2V1Z",
    fill: "#3A3428",
    mask: "url(#path-1-outside-1_201_1151)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00052 9.93337L5.73385 13.2C5.61163 13.3223 5.45608 13.3834 5.26719 13.3834C5.0783 13.3834 4.92274 13.3223 4.80052 13.2C4.6783 13.0778 4.61719 12.9223 4.61719 12.7334C4.61719 12.5445 4.6783 12.3889 4.80052 12.2667L8.06719 9.00003L4.80052 5.73337C4.6783 5.61114 4.61719 5.45559 4.61719 5.2667C4.61719 5.07781 4.6783 4.92225 4.80052 4.80003C4.92274 4.67781 5.0783 4.6167 5.26719 4.6167C5.45608 4.6167 5.61163 4.67781 5.73385 4.80003L9.00052 8.0667L12.2672 4.80003C12.3894 4.67781 12.545 4.6167 12.7339 4.6167C12.9227 4.6167 13.0783 4.67781 13.2005 4.80003C13.3227 4.92225 13.3839 5.07781 13.3839 5.2667C13.3839 5.45559 13.3227 5.61114 13.2005 5.73337L9.93385 9.00003L13.2005 12.2667C13.3227 12.3889 13.3839 12.5445 13.3839 12.7334C13.3839 12.9223 13.3227 13.0778 13.2005 13.2C13.0783 13.3223 12.9227 13.3834 12.7339 13.3834C12.545 13.3834 12.3894 13.3223 12.2672 13.2L9.00052 9.93337Z",
    fill: "#3A3428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongIcon);
export default __webpack_public_path__ + "static/media/wrongIcon.d6662d5730e30f7dcfdffaae0700c401.svg";
export { ForwardRef as ReactComponent };